import UseView from './Use.View';

const Use = () => <UseView />;

export default Use;
